<template>
  <div class="faqContainer">
      <div class="toppurple faqmobile"></div>
      <div class="backgroundcontainer">

        <input
          id="faqSearch"
          v-model="query"
          type="text"
          placeholder="در چه زمینه ای سوال دارید؟"
        >
        <div class="container">
          <div
            :class="obj.show? 'faq open farsi' : 'faq farsi'"
            v-for="obj in getFaq()"
            :key="obj.id"
          >
            <div
              class="faq-title"
              @click="toggle(obj)"
              v-html="obj.name"
            ></div>

            <!-- <div class="QuestionsContainer" v-if="obj.show"> -->
            <div
              title='سوالات متداول ۷۰۳۰'
              class="faq-body farsi"
              v-for="question in obj.questionArray"
              @click="[openModal('faq'),$store.state.question=question]"
              :key="question.id"
              v-html="question.question"
            >
            
            </div>
            <!-- </div> -->
          </div>
        </div>
      </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  data() {
    return {
      searchResult: [
        {
          show: false,
          id: 1,
          name: "ثبت نام و عضویت",
          questionArray: [
            {
              id: 1,
              question: ` <hr/>چطور ثبت نام کنم؟ مراحل ثبت نام رو توضیح بدید. `,
              answer: `
                1- در قسمت "ثبت نام" شماره موبایلتون رو وارد کنید..
                <br/>
                2- رمز عبور دلخواهتون رو ثبت کرده و به خاطر بسپارید.
                <br/>
                3-  اگر کسی سامانه هفتادسی رو به شما معرفی کرده شناسه‌ی دعوتش رو در قسمت مربوطه وارد کنید.
                <br/>
                4- پس از دریافت پیامک حاوی کد فعالسازی، اون رو در کادر مربوطه وارد کنید.
                                `,
            },
            {
              id: 2,
              question: `چرا کد فعالسازی (کد تایید) ارسال نمیشه؟`,
              answer: `
              گاهی ممکنه کد فعالسازی با تاخیر به دست شما برسه؛ اگر کد فعالسازی رو دریافت نکردید و یا دریافت کردید و اشتباه بود، ابتدا عدد 1 رو به سامانه 10000070307030 ارسال و سپس از قسمت "ورود" وارد برنامه بشید. در صورتی که مشکل برطرف نشد، با واحد پشتیبانی ارتباط برقرار کنید.
                                `,
            },
            {
              id: 3,
              question: `شناسه دعوت رو در کدوم قسمت وارد کنم؟`,
              answer: `هنگام ثبت نام، بعد از وارد کردن شماره موبایل و رمز عبور، قسمت مربوط به وارد کردن شناسه دعوت نشون داده میشه، اگر از قبل اون قسمت با یک شناسه­ دعوت پُر شده، یعنی شما از طریق لینکی که حاوی شناسه دعوت بوده وارد شده‌اید.`,
            },
            {
              id: 4,
              question: `آیا پس از ثبت نام میتونم شناسه‌ای که با اون دعوت شده‌­ام رو عوض کنم؟`,
              answer: `خیر؛ به خاطر قدردانی از زحمات کسی که شما رو با سامانه هفتادسی آشنا کرده امکان تغییر شناسه دعوت پس از ثبت نام به هیچ عنوان وجود نداره؛ می‌تونید با یک شماره موبایل دیگه مجدداً ثبت نام کنید و شناسه دعوت درست رو وارد کنید.`,
            },
            {
              id: 5,
              question: `رمز ورود رو فراموش کرده‌ام، چطور اون رو بازیابی کنم؟`,
              answer: `در قسمت "ورود" از گزینه‌ی " کلمه عبور را فراموش کرده‌ام" استفاده کنید.`,
            },
            {
              id: 6,
              question: `چطور میشه با دو سیم کارت ثبت نام کرد؟`,
              answer: `پس از ثبت نام با سیم کارت اول، می‌تونید از بخش پروفایل/سه نقطه‌ی بالای صفحه در سمت چپ، گزینه خروج رو بزنید، سپس با سیم کارت جدید ثبت نام بفرمایید.`,
            },
            {
              id: 7,
              question: `میشه با چند نام و شناسه فعالیت کرد؟`,
              answer: `بله؛ شما با هر شماره موبایل می‌تونید یک حساب کاربری داشته باشید، با هر حساب کاربری هم با لحاظ جمیع شرایط، می‌تونید تا سقف 5 شناسه دعوت که معرف اسم، اسم کانال یا صفحه، نام کسب و کار یا برند شماست، ثبت کرده و با اون ها به فعالیت و جذب مدعو بپردازید.`
                
                },
            {
              id: 8,
              question: `خودم با هفتادسی آشنا شده‌ام و کسی سامانه رو بهم معرفی نکرده، شناسه دعوت برای ثبت نام ندارم چکار کنم؟`,
              answer: `در صورتی که قصد ثبت نام با شناسه دعوت دارید می‌تونید شناسه‌ی دعوت هفتادسی، ir_7030  رو وارد کنید؛ لازمه بدونید که تفاوتی بین شناسه‌ها از نظر سوددهی وجود نداره`,
            },
            {
              id: 9,
              question: `چطور شماره موبایلی که با اون ثبت  نام کردم یا حساب کاربری خودم رو  به طور کامل حذف یا لغو عضویت کنم؟`,
              answer: `در هفتادسی هر کاربر با شماره موبایلی که ثبت نام میکنه شناخته میشه. از اونجا که در هفتادسی تراکنش مالی انجام میشه و طبق قوانین تجارت الکترونیک کشور این تراکنش‌ها باید ثبت و ذخیره بشن، امکان حذف کامل حساب کاربری یا شماره موبایل وجود نداره.`,
            },
          ],
        },
        {
          show: false,
          id: 2,
          name: "دعوت دوستان و جذب مدعو",
          questionArray: [
            {
              id: 8,
              question: ` <hr/>آیا محدودیت دعوت وجود داره؟ `,
              answer: `هیچ محدودیتی در تعداد دعوت وجود نداره و شما می‌تونید با کد معرفتون به تعداد نامحدود مدعو داشته باشید.`,
            },
            {
              id: 9,
              question: `ایجاد شناسه دعوت و معرفی دیگران چطور انجام میشه؟`,
              answer: `پس از ثبت نام، شماره موبایل شما به صورت پیش فرض به عنوان شناسه دعوت شناخته میشه؛ برای ساخت شناسه‌هایی غیر از  شماره موبایل، در اپلیکیشن با در نظر گرفتن جمیع شرایط از قسمت "پروفایل / کسب درآمد" گزینه‌ی "ساخت شناسه جدید" رو انتخاب بفرمایید. در نسخه سایت هم در قسمت " شناسه‌ها و مدعوین "  با کلیک بر روی گزینه "افزودن شناسه جدید" شناسه‌های دلخواهتون رو ایجاد و با "فرستادن دعوتنامه" اون‌ها رو منتشر کنید.`,
            },
            {
              id: 10,
              question: `افرادی که معرفی کردم یا تعداد مدعوین رو  از کجا میتونم ببینم؟`,
              answer: `در اپلیکیشن از مسیر پروفایل/کسب درآمد، با کلیک روی هر یک از شناسه‌ها، تعداد مدعوین اون شناسه و بخشی از شماره موبایلشون نمایش داده میشه.`,
            },
            {
              id: 11,
              question: `سود دریافتی از هفتادسی رو از کجا میتونم ببینم؟`,
              answer: `در اپلیکیشن از مسیر پروفایل/کسب درآمد، روی گزینه‌ی "جزییات حساب" کلیک کنید، سود دریافتی از تراکنش های خودتون و مدعوینتون نشون داده میشه.`,
            },
            {
              id: 12,
              question: `چرا هر شناسه‌ای می‌خواهم بسازم قبول نمی‌کنه، ساخت شناسه دعوت چه شرایطی داره؟`,
              answer: `شناسه‌ای که می‌سازید باید شرایط زیر رو داشته باشه:
              <br/>
                1. از کاراکترها و اعداد انگلیسی در شناسه استفاده بشه
              <br/>
                2.از قبل توسط شخص دیگه‌ای انتخاب نشده باشه
              <br/>
                3.حدقل 5 کاراکتر(عدد یا حرف) داشته باشه
              <br/>
                4.بین کاراکترها فقط از علامت (_) میشه استفاده کرد
              `,
            },
            {
              id: 13,
              question: `چطور شناسه‌هایی که ساختیم رو حذف کنیم  و  بعد از  حذف، وضعیت مدعوین اون شناسه چطور میشه؟`,
              answer: `با کلیک روی هر شناسه دعوت در قسمت "کسب درآمد" امکان حذف اون فراهم شده ولی در صورتی که بعد از حذف، اون شناسه توسط شخص دیگه‌ای رزرو بشه ، امکان بازپس‌گیری اون وجود نخواهد داشت. بعد از حذف شناسه، مدعوین اون شناسه در قسمت "مدعوین شناسه‌های حذف شده" قابل مشاهده است.`,
            },
            {
              id: 14,
              question: `جهت تبلیغات و آموزش به افراد دعوت شده مطالب و تصاویر گرافیکی آماده دارید؟`,
              answer: `بله؛ برای دسترسی به این موارد می‌تونید در کانال تلگرام ما با آی-دی:  ir_7030   ، کلمه‌ی "متریال" رو جستجو کنید.`,
            },
            {
              id: 15,
              question: `چرا در اینستاگرام نمیشه لینک هفتادسی رو به اشتراک گذاشت؟`,
              answer: `به دليل استفاده بسیار زیاد كاربران و دعوت‌كنندگان از لينک سايت هفتادسی متاسفانه اينستاگرام اين لينك رو به عنوان لينك اسپم شناسايی كرده و از انتشار اون جلوگيری میكنه. تا رفع این مشکل كاربران عزيز میتونن برای اشتراك كد معرفشون فقط از شناسه معرف(بدون قرار دادن لینک هفتادسی در متن) استفاده کنن.همچنین تصاویر و بنرهای مناسبی برای تبلیغ در اینستاگرام فراهم شده که در کانال تلگرام(با عنوان متریال) می‌تونید پیداشون کنید.`,
            },
          ],
        },
        {
          show: false,
          id: 3,
          name: "درآمدزایی از هفتادسی",
          questionArray: [
            {
              id: 17,
              question: `<hr/>چگونه درآمدزایی کنم؟`,
              answer: `درآمدزایی از طریق جذب کاربران و سهیم شدن در سود تراکنش‌هاشون ایجاد میشه. هر تراکنشی که شما یا مدعوین شما (کاربرانی که با شناسه دعوت شما ثبت نام کردن) انجام میدید، سود مشخصی داره که به اعتبار شما در سامانه اضافه میشه. شما می‌تونید این اعتبار رو برداشت یا با اون خرید انجام بدید. طبیعتاً تعداد مدعوین بیشتر و به دنبالش افزایش تراکنش‌ها، درآمد بیشتری برای شما در پی خواهد داشت.`,
            },
            {
              id: 18,
              question: `درآمد من چطور پرداخت میشه؟`,
              answer: `سود تراکنش‌ها با واحد "تومان" به اعتبار شما در سامانه اضافه میشه و جهت برداشتش هر زمان که تمایل داشته باشید، می‌تونید در قسمت "پروفایل / اعتبار" مراحل درخواست واریز رو انجام بدید.1- مبلغ نهایتا تا 3 روزکاری (3 روز غیر تعطیل) به حساب شما واریز میشه. 2- حداقل مبلغ قابل واریز  10000 تومانه`,
            },
            {
              id: 19,
              question: `چرا به شماره شبا نیازه؟ چطور میشه شماره شبا رو  دریافت کرد؟`,
              answer: `شبا(شناسه بانکی ایران)متشکل از 24 رقمه و روی بعضی از کارت‌های بانکی درج شده؛ شبا رو به دو طریق میشه به دست آورد:
              <br/>
               1- مراجعه حضوری به بانک یا عابر بانک مربوطه
               <br/>
               2. دریافت اون از طریق وبسایت بانک مربوطه`,
            },
            {
              id: 20,
              question: `طرح درآمدی (پلن درآمدی) به چه صورته؟`,
              answer: `هفتادسی، هفتاد درصد از سود خالص فروش محصولات رو به کاربران اختصاص داده و  این سود با در نظر گرفتن محدویت‌ها و الزامات قانونی در یک سطح تقسیم میشه. به عبارتی از هفتاد درصد سودی که کاربران از فروش هر محصول میبرن، ۴۰ درصد به معرف و ۳۰ درصد مابقی به خریدار تعلق میگیره. تلاش شده که تقسیم سود متناسب با زحمت کاربران در تبلیغ و معرفی سامانه باشه. لطفا به تبلیغات و محتواهای متنی و ویدئویی که برپایه‌ی سوددهی چندسطحی،درآمد ثابت ماهانه  و ... منتشر میشه توجه نفرمایید و معیارتون رو قوانین و مقررات سایت هفتادسی قرار بدید. مادامی که قانون فروش و بازاریابی شبکه‌ای برای محصولات و خدماتی که هفتادسی ارائه می‌کنه، ابلاغ و توسط نهادهای دولتی اجرایی نشه، هفتادسی نمیتونه به صورت چند سطحی سوددهی انجام بده. هرگونه تغییر درباره‌ی نحوه‌ی سوددهی از طریق رسانه‌های رسمی سامانه اطلاع رسانی خواهد شد.`,
            },
            {
              id: 21,
              question: `میزان دقیق سود هر خرید چقدره؟`,
              answer: `
              مقدار سود هر محصول بستگی به قیمتش و شرکتی که اون رو برای ما تامین میکنه و با اون قرارداد منعقد کرده‌ایم، داره:
              <br/>
              ✅تمام سود فروش هر کد شارژ : 2.3 درصد از مبلغ کل محصول
              <br/>
             ✅تمام سود فروش شارژ مستقیم ایرانسل: 2.9 درصد از مبلغ کل محصول
              <br/>
             ✅تمام سود فروش شارژ مستقیم رایتل: 3.2 درصد از مبلغ کل محصول
              <br/>
             ✅تمام سود فروش شارژ مستقیم همراه اول: 2.3 درصد از مبلغ کل محصول
              <br/>
              ✅تمام سود فروش بسته های اینترنت ایرانسل 2.9 درصد و بسته های اینترنت سایر اپراتورها 3.2 درصد از مبلغ کل محصوله
              <br/>
             یعنی مثلا تمام سود یک شارژ مستقیم ۱۰ هزار تومانی ایرانسل 290 تومان، کل سود شارژ  ۱۰ هزار تومانی رایتل، 320 تومان و کل سود یک شارژ ۱۰ هزار تومانی همراه اول 230 تومانه که 40 درصد اون سهم معرف و 30 درصدش سهم خریداره
              <br/>
              ✅سرویس انتقال وجه در حال حاضر مستقیما توسط درگاه بانکی انجام شده و به سامانه هفتادسی سودی پرداخت نمیشه ؛ با بالا رفتن حجم تراکنش‌ها، میتونیم با درگاه بانکی جهت دریافت سود، مذاکره و در صورتی که سودی پرداخت بشه حتما برای کاربران نیز در نظر گرفته و اطلاع رسانی خواهد شد.
              <br/>

                            `,            },
            {
              id: 22,
              question: `با توجه به سود کم محصولاتی مثل شارژ و بسته‌ی اینترنت، ارزش داره وقتمون رو صرف این کار کنیم؟`,
              answer: `بله؛ در بازار فعلی سود فروش شارژ سیم کارت‌های اعتباری حدود ۶۰ میلیارد تومان در ماه و در سال حدود ۷۲۰ میلیارد تومان هست، که اگر ما بتونیم حتی یک درصد از بازار شارژ رو پوشش بدیم، در سال مبلغ ۷.۲ میلیارد تومان سود خواهیم داشت که ۷۰% از این مبلغ یعنی، ۵ میلیارد تومان به کاربران تعلق داره . ضمن اینکه سایر محصولات ارائه شده در سامانه هم (پرداخت‌ قبض، بسته‌های اینترنتی، خرید بیمه) هر کدوم سود مختص به خودشون رو دارن که اون هم رقم قابل توجهی خواهد بود.`,
            },
            {
              id: 23,
              question: `چه تضمینی وجود داره که همیشه 70 درصد از سودتون رو به کاربران پرداخت کنید؟`,
              answer: `اساساً هدف اصلی هفتادسی از ابتدای تاسیس این بوده که به جای هزینه‌های گزاف تبلیغات تلویزیونی و ...، این مبالغ رو به عنوان سود تراکنش‌ها و پاداش فعالیت به کاربران هدیه کنه؛ همونطور که از اسم هفتادسی هم پیداست 70 درصد از سود تراکنش همواره به کاربران تقدیم میشه؛ قطعا بزرگترین سرمایه هفتادسی کاربران فعال هستن و باید رضایت اون‌ها حاصل بشه.`,
            },
          ],
        },
        {
          show: false,
          id: 4,
          name: "برداشت وجه و افزایش اعتبار",
          questionArray: [
            {
              id: 25,
              question: `<hr/>چرا با اینکه درآمدم از هفتادسی بیشتر از ده هزار تومانه، نمی‌تونم درخواست واریز ثبت کنم و خطای کمبود اعتبار میده؟`,
              answer: `"درآمد از هفتادسی" میزان درآمدیه که شما از ابتدای عضویت در سامانه کسب کردید و جنبه‌ی اطلاع رسانی داره ؛ ثبت درخواست واریز وجه و یا خرید محصول بر مبنای "اعتبار فعلی" انجام میشه؛ اگر سابقاً هیچ خریدی با اعتبار انجام نداده باشید، میزان "اعتبار فعلی" و "درآمد از هفتادسی" شما یکسان خواهد بود، در غیر اینصورت اعتبار فعلی کمتر از درآمد از هفتادسی نشون داده میشه. نکته: تمامی مبالغ و ارقام در هفتادسی بر اساس واحد "تومان" نشون داده میشن.
              `,
            },
            {
              id: 26,
              question: `درخواست واریز زدم، چرا مبلغ رو از اعتبار من کم کرده ولی به حساب بانکی من واریز نشد؟`,
              answer: `زمانی که درخواست واریز ثبت می‌کنید، مبلغ از اعتبار شما خارج شده و در صف واریز قرار میگیره، (به اصطلاح hold میشه) تا از طریق امور مالی، به حساب شما حواله‌ی پایا بشه؛ این فرآیند ممکنه از 1 تا 3 روز کاری زمانبر باشه.`,
            },
            {
              id: 27,
              question: `برای برداشت مبلغی که خودم افزایش اعتبار داده ام چه کاری باید انجام بدم؟`,
              answer: `افزایش اعتبار برای تسهیل فرآیند خرید بوده و اساساً امکان برداشت این دسته از مبالغ وجود نداره؛ در موارد اضطراری و بنا به صلاحدید واحد مالی، طبق دستورالعمل های ابلاغ شده از مراجع قانونی مبلغ فقط به کارتی که افزایش اعتبار با اون انجام شده عودت میشه و همچنین اطلاعات هویتی صاحب کارت باید به شرح زیر دریافت بشه:
              <br/>
              1. تصویر کارتی که افزایش اعتبار با اون انجام شده (جهت حفظ امنیت بیشتر تاریخ انقضا و CVV2 پوشانده بشه) 
              <br/>
              2. تصویر کارت ملی صاحب کارت
              <br/>
              3. یک برگه که روی اون شماره موبایل کاربری، تاریخ، امضا و شماره شبای کارت مورد نظر نوشته شده باشه
          لازم به ذکره که هر سه مورد حتما باید در یک عکس قرار گرفته باشن.
              `,
            },
          ],
        },
        {
          show: false,
          id: 5,
          name: "خرید شارژ و بسته اینترنت",
          questionArray: [
            {
              id: 28,
              question: `<hr/>آیا قیمت های محصولات شما از جاهای دیگه بیشتره؟`,
              answer: `کد شارژهایی که خریداری می نمایید در بخش تراکنشها قرار میگیرن، دراین بخش روی تراکنش مربوطه کلیک کنید، کد شارژ شما قابل مشاهده و استفاده است.؛`,
            },
            {
              id: 29,
              question: `کد شارژ خریدم، کجا میتونم ببینم و استفاده کنم؟`,
              answer: `کد شارژهای خریداری شده، هم در بخش تراکنش‌ها و هم در بخش پیام‌های برنامه ثبت میشن و هم اینکه به شماره موبایل کاربری تون پیامک میشن.`,
            },
            {
              id: 30,
              question: ` برای خرید بیش از سقف تعیین شده در روز چه کاری باید انجام داد؟`,
              answer: `خرید هر چه بیشتر کاربران باعث خرسندی ماست؛ ولی برای حفظ امنیت کاربران و رعایت قوانین تجارت الکترونیک، افزایش اعتبار و یا خرید بیش از سقف تعیین شده، نیاز به احراز هویت حساب کاربر و کارتی که با اون پرداخت میشه هست. لازمه اطلاعات هویتی صاحب حساب کاربری به شرح زیر دریافت بشه:
              <br/>
               1. تصویر کارتی که افزایش اعتبار با اون انجام شده (جهت حفظ امنیت بیشتر تاریخ انقضا و CVV2 پوشانده بشه) 
               <br/>
              2. تصویر کارت ملی صاحب کارت
               <br/>
               3. یک برگه که روی آن شماره موبایل کاربری و تاریخ روز نوشته شده باشه؛ لازم به ذکره که هر 3 مورد باید در یک عکس قرار گرفته باشن`,
            },
            {
              id: 31,
              question: `آیا شارژ یا بسته اینترنت خریداری شده ، پس از فعال شدن امکان بازگشت داره؟`,
              answer: `خیر؛ از اونجایی که شارژ و بسته اینترنت مستقیما از سمت اپراتور بر روی خط شما فعال میشه، به هیچ وجه از سمت ما قابل بازگشت نیست.`,
            },
          ],
        },
        {
          show: false,
          id: 6,
          name: " پرداخت قبض",
          questionArray: [
            {
              id: 32,
              question: `<hr/>پرداخت قبض انجام دادم که ناموفقه ولی پول از حسابم کسر شده، چکار کنم؟`,
              answer: `گاهی اوقات پرداخت قبوض به اشتباه پرداخت نشده نمایش داده میشن ، درصورتی که پرداخت موفق بوده (دلیلش عدم پاسخ دهی بانک در اون لحظه به ما هست). درنتیجه همکاران به صورت دوره ای پرداخت قبض هایی که ناموفق اعلام شده اند رو بررسی مجدد کرده و ایراد رو برطرف می کنند، در این خصوص جای هیچ نگرانی نیست و سود تمام تراکنش های شما لحاظ خواهد شد. لطفا کد پیگیری (شماره مرجع) 12 رقمی تراکنش، یا شماره کارتی که با اون پرداخت نموده اید رو به پشتیبانی سامانه ارسال کنید تا پیگیری های لازم از درگاه بانکی انجام بشه.`,
            },
            {
              id: 33,
              question: `آیا پرداخت قبض و یا انتقال وجه با اعتبار درون برنامه ای هفتادسی امکان پذیره؟`,
              answer: `خیر، به دلیل اینکه پرداخت قبض و انتقال وجه عملیات بانکی محسوب میشه و قبوض رو بانک با سازمان صادر کننده ی اون تسویه می‌کنه این عملیات فقط از طریق درگاه بانکی قابل انجامه و با اعتبار درون برنامه‌ای هفتادسی امکان پرداخت ندارن. برای خرید محصولات اعتباری می‌تونید از اعتبارتون استفاده بفرمایید.`,
            },
            {
              id: 34,
              question: `قبض پرداخت کردم، چقدر زمان می بره تا بدهی من در سازمان مربوطه صفر بشه؟`,
              answer: `تسویه حساب بانک با سازمان ها معمولا هر روز کاری(غیر تعطیل) انجام میشه، ولی زمان بروزرسانی در سازمان‌ها و صفر کردن بدهی متفاوته، بعضی سازمان‌ها سریع و بعضی کندتر عمل میکنن، به عنوان مثال تسویه قبوض جرائم راهنمایی و رانندگی با توجه به شرایط ویژه ناجا و عدم به روزرسانی روزانه سیستم پرداخت، گاهی اوقات تا 3 هفته زمان می‌بره. پیشنهاد می‌کنیم برای تسویه‌ی لحظه‌ای قبض ایرانسل سیم کارت مورد نظر رو از قسمت ویترین مستقیما شارژ کنید و برای تسویه‌ی لحظه‌ای قبض همراه اول، قبض رو از درگاه به پرداخت ملت پرداخت بفرمایید.`,
            },
          ],
        },
        {
          show: false,
          id: 7,
          name: "کارت به کارت",
          questionArray: [
            {
              id: 38,
              question: `<hr/>با کارت چه بانک هایی میشه کارت به کارت کرد؟`,
              answer: `در حال حاضر با سه بانک پارسیان، انصار و توسعه تعاون به عنوان کارت مبدا میشه به هر بانک مقصدی انتقال وجه انجام داد. مجوزهای بانک‌های دیگه هم اخذ شده و به زودی در سامانه پیاده‌سازی و اجرا خواهند شد.`,
            },
            {
              id: 39,
              question: `سود کارت به کارت چطور محاسبه میشه؟`,
              answer: `سرویس کارت به کارت مستقیماً توسط درگاه بانکی انجام شده و بابتش به سامانه هفتادسی سودی پرداخت نمیشه. به زودی با بالا رفتن حجم تراکنش‌ها، میشه با درگاه بانکی جهت دریافت سود، مذاکره کرد.`,
            },
            {
              id: 40,
              question: `آیا از طریق سایت هم میشه کارت به کارت کرد؟`,
              answer: `خیر؛ کارت به کارت فقط از طریق اپلیکیشن امکان پذیره.`,
            },
            {
              id: 41,
              question: `تراکنش کارت به کارت انجام دادم ولی پول منتقل نشده، چطور میتونم پیگیری کنم؟`,
              answer: `با توجه به اینکه کارت به کارت، مستقیما از درگاه بانک پارسیان انجام میشه، پیگیری تراکنش توسط پشتیبانی درگاه با شماره تماس
 2318-021  قابل انجامه.`,
            },
          ],
        },
        {
          show: false,
          id: 8,
          name: "خرید بیمه",
          questionArray: [
            {
              id: 41,
              question: `<hr/>چطور می‌تونم بیمه‌هایی که در سامانه ثبت نام کردم رو مشاهده کنم؟`,
              answer: `از قسمت "ویترین/بیمه/ خودرو/ بیمه های من" ، می‌تونید مشاهده کنید.`,
            },
            {
              id: 42,
              question: `چرا سود بیمه‌ای که خریدم به اعتبار کاربریم در سامانه اضافه نشده ؟`,
              answer: `تسویه‌ی سود بیمه نامه‌های خریداری شده ماهانه انجام میشه و در پایان هر ماه سود اون‌ها به اعتبار درون برنامه‌ای کاربران اضافه خواهد شد.`,
            },
          ],
        },
        // {
        //   show: false,
        //   id: 9,
        //   name: "خرید بلیط هواپیما",
        //   questionArray: [
        //     {
        //       id: 46,
        //       question: `میخوام یه بلیط بگیرم در برنامه هفتادسی نمیتونم پیداش کنم درحالی که در دیگر سامانه ها همون بلیط وجود داره؟`,
        //       answer: `چنین چیزی امکان نداره و در 99 درصد موارد با رفرش کردن برنامه تمام پروازها آپدیت خواهند شد.`,
        //     },
        //     {
        //       id: 47,
        //       question: `پروازم از طرف ایرلاین کنسل شده چطور میتونم پولمو بگیرم؟`,
        //       answer: `در سایت های هالیدی باید فرم استرداد رو پر کنید و مبلغ بلیط کنسل شده نیز به همون شماره کارت یا حسابی واریز میشه که در اون فرم وارد می کنید، مابه التفاوت مبلغ بلیط هم به اعتبار درون برنامه ایتون در سامانه،اضافه میشه.`,
        //     },
        //     {
        //       id: 48,
        //       question: `مشکلی پیش اومده و میخوام پروازم رو کنسل کنم، چه کار باید انجام دهم؟`,
        //       answer: `باید در سایت های هالیدی فرم استرداد بلیط پر کنید و بسته به نوع پرواز (سیستمی یا چارتر)، در صورتی که امکان کنسلی داشته باشه، مبلغ بلیط با احتساب جریمه، به شماره حساب یا کارت ثبت شده توسط شما، واریز خواهد شد.`,
        //     },
        //     {
        //       id: 49,
        //       question: `پس از دو ساعت از زمان پرواز، در فرودگاه به ما اعلام کردن که پروازتون کنسله، چطور میتونم پول بلطیمو بگیرم؟`,
        //       answer: `باید بلیطتون رو در دفتر ایرلاین مربوطه مهر بزنید و پس از تکیمل فرم استرداد در سایت های هالیدی، تصویر بلیط رو نیز در قسمت پشتیبانی برای ما بفرستین تا روند پیگیری اون انجام بشه.`,
        //     },
        //     {
        //       id: 50,
        //       question: `برام از طرف ایرلاین یا آژانس پیامک اومده که پروازم با دو ساعت تاخیر یا تعجیل همراهه، چطور میتونم پرواز رو کنسل و پولم رو بگیرم؟`,
        //       answer: `در صورتی که تاخیر یا تعجیل اعلام شده زیر دو ساعت باشه، مشروط به عدم تغییر شماره پرواز، امکان کنسل بلیط نیست اما در صورتی که بالای دو ساعت باشه، پس از تکیمل فرم استرداد در سایت های هالیدی و انعکاس موضوع به پشتیبانی سامانه، کل مبلغ بلیط عودت داده خواهد شد.`,
        //     },
        //   ],
        // },
        {
          show: false,
          id: 10,
          name: "درگاه بانکی و پرداخت",
          questionArray: [
            {
              id: 51,
              question: `<hr/>آیا برای هر خرید باید تمام اطلاعات کارت بانکیمون (شماره کارت، تاریخ انقضاء و ...) رو وارد کنیم؟`,
              answer: `خیر؛ بعد از ورود به درگاه بانک، می‌تونید با فعال کردن تیکِ گزینه‌ی "ذخیره‌ی اطلاعات کارت"،شماره کارت و تاریخ انقضای اون رو در همون درگاه ذخیره کنید. همچنین برای خرید راحت‌تر  و سریع‌تر می‌تونید افزایش اعتبار بدید و بدون ورود به درگاه بانک و استفاده از کارت، مبلغ خریدتون رو از اعتبار پرداخت کنید.`,
            },
            {
              id: 52,
              question: `پیغام "تراکنش توسط دارنده کارت مجاز نیست" به چه علت دریافت میشه؟`,
              answer: `بعضی بانک‌ها برای بعضی از درگاه‌ها، محدودیت حداقل مبلغ تراکنش قرار داده‌اند، مثلا بانک ملت محدودیت حداقل مبلغ 10 هزار تومان یا بانک انصار  محدودیت حداقل 5 هزار تومن داره و تراکنش‌های کمتر از این مبلغ  رو نمی‌پذیره.چنین مواقعی برای استفاده از کارت بانک ملت می‌تونید از درگاه اینترنتی به پرداخت ملت اقدام بفرمایید. همچنین اگر قصد خرید دارید،می‌تونید با هر مبلغی افزایش اعتبار بدید و خریدهاتون رو با اعتبار پرداخت کنید.`,
            },
            {
              id: 53,
              question: `چرا بعضی پرداخت‌ها با مشکل مواجه می‌­شن؟`,
              answer: `گاهی اوقات ممکنه به دلایلی از جمله عدم پاسخ دهی آنی بانک و یا تامین کننده، برخی تراکنش‌ها با خطا مواجه بشن. در صورت کسر مبلغ از حسابتون، درگاه بانکی حداکثر تا 72 ساعت مبلغ کسر شده رو عودت میده. برای بررسی دقیقتر تراکنش هاتون می‌تونید شماره مرجع تراکنش یا شماره کارتی که با اون پرداخت رو انجام دادید برای همکاران ما در واحد پشتیبانی ارسال کنید تا پیگیری های لازم انجام بشه.`,
            },
            {
              id: 54,
              question: `علی‌رغم گذشت 72 ساعت از انجام تراکنش (ناموفق) هنوز مبلغش به حسابم برگشت نخورده، چه کاری باید انجام بدم؟`,
              answer: `گاهی اوقات پیامک اصلاح از  بانک ارسال نمیشه و یا مبلغ تراکنش ناموفق رو به همراه سود اون به حساب کاربر عودت میدن (حدود 1000 تومان)، به همین خاطر لازمه که گردش حساب بانکیتون رو بررسی کنید و از عودت یا عدم عودت مبلغ تراکنش مطمئن بشید، در صورتی که برنگشته باشه می‌تونید با واحد امداد شتاب با شماره 29911-021 تماس بگیرید و پیگیری بفرمایید.`,
            },
            {
              id: 55,
              question: `هفتادسی در تبلیغاتش ادعای خرید سریع و آسان می‌کنه، روش خرید سریع چطوره؟`,
              answer: `سریعترین روش خرید، پرداخت با اعتباره .کاربر میتونه از طریق درآمدی که از هفتادسی کسب کرده و یا با افزایش اعتبار درون برنامه‌ای به میزان مورد نیاز برای خریدهایی که قراره انجام بده، فقط با یک کلیک پرداخت کنه.`,
            },
          ],
        },
        {
          show: false,
          id: 11,
          name: "امنیت و مجوزها",
          questionArray: [
            {
              id: 56,
              question: `<hr/>هنگام پرداخت چگونه به هفتادسی اعتماد و اطلاعات کارتمون رو وارد کنیم؟`,
              answer: `همه‌ی پرداخت‌ها مستقیماً از طریق درگاه بانکی انجام میشن؛ تمامی اطلاعاتی که در زمان پرداخت وارد می‌کنید، فقط در درگاه بانکی وارد شده و به هیچ‌ عنوان در هفتادسی ثبت یا ذخیره نخواهند شد.`,
            },
            {
              id: 57,
              question: `آیا سیستم هفتادسی امن و قابل اطمینانه؟`,
              answer: `بله؛ هفتادسی با استانداردها و تکنولوژی روز و امنیت بالا طراحی و پیاده سازی شده و در پرداخت‌ها هم از درگاه‌های امن بانکی استفاده میکنه. هفتادسی صرفاً یک واسطه و رابط بین فروشنده و خریدار هست و اطلاعات بانکی حساب شما به هیچ وجه در سرورهای هفتادسی ذخیره نمیشن .`,
            },
            {
              id: 58,
              question: `مجوز های 7030 را از کجا میتوان مشاهده کرد؟`,
              answer: `در لینک زیر مجوزهای سایت را میتونید مشاهده کنید؛ https://7030.ir/enemad همچنین میتونید به سایت enamad.ir مراجعه کنید و در قسمت استعلام، با وارد کردن آدرس: 7030.ir نتیجه را مشاهده بفرمایید؛`,
            },
            {
              id: 59,
              question: `آیا هفتادسی قانونیه؟`,
              answer: `بله؛ اختصاص سود به بازاریابان در همه‌ی کسب و کارها مرسوم بوده و در حال انجامه. سایت هفتادسی مجوزهای نظارت بر کسب و کارهای دیجیتال وزارت صنعت، معدن و تجارت (Enamad)، مجوز مرکز ساماندهی رسانه‌های دیجیتال وزارت ارشاد و مجوز انجمن صنفی کسب و کار اینترنتی و گواهی ارزیابی امنیتی رو دریافت کرده.`,
            },
            {
              id:60,
              question:`مجوز های هفتادسی رو  از کجا میشه مشاهده کرد؟`,
              answer:`مجوزهای قانونی و امنیتی هفتادسی رو می‌تونید از   <a target=_blank href="https://7030.ir/enamad" class="colorSecondary">اینجا </a>مشاهده کنید.همچنین برای مشاهده ی نماد اعتماد الکترونیکی می‌تونید به سایت enamad.ir مراجعه و در قسمت استعلام، با وارد کردن آدرس   7030.ir  نتیجه رو ببینید.`
            }
          ],
        },
        {
          show: false,
          id: 12,
          name: "دانلود اپلیکیشن، آپدیت‌ها و برنامه‌های آینده",
          questionArray: [
            {
              id: 60,
              question: `<hr/>چطور میتونم اپلیکیشن رو دانلود یا بروزرسانی کنم؟`,
              answer: `از طریق لینک زیر می‌تونید نسخه متناسب با گوشیتون رو از مارکت‌های معتبر دانلود یا بروزرسانی بفرمایید:
              <br/>
              <a target=_blank href="https://7030.ir/download" class="colorSecondary">لینک دانلود اپلیکشن </a>`,
            },
            {
              id: 61,
              question: `روش دانلود اپلیکیشن در گوشی‌های آیفون چطوره؟`,
              answer: `به دلیل محدودیت های اعمال شده از سوی اپل برای اپلیکیشن‌های ایرانی، در حال حاضر نسخه "آی او اس" برنامه  در مارکت های سیبچه، سیب ایرانی، اناردونی و آی اپس قابل دانلوده.
              <br/><a target="_blank" href="https://sibche.com/applications/7030-1" class="colorSecondary"> دانلود از سیبچه  </a>
              <br/><a target=_blank href="https://anardoni.com/ios/app/2qr0XbRxg?lng=fa" class="colorSecondary"> دانلود از اناردونی </a>
              <br/><a target="_blank" href="https://sibirani.ir/apps/%D9%87%D9%81%D8%AA%D8%A7%D8%AF%D8%B3%DB%8C-7030/" class="colorSecondary"> دانلود از سیب ایرانی  </a>
              <br/><a target="_blank" href="https://iapps.ir/app/%D9%87%D9%81%D8%AA%D8%A7%D8%AF%D8%B3%DB%8C-7030/509472634" class="colorSecondary"> دانلود از آی اپس  </a>
              `,
            },
            {
              id: 62,
              question: `چرا برای دانلود نسخه آی او اس هفتادسی از مارکت هایی مثل سیبچه و ... باید پول پرداخت کنیم؟`,
              answer: `هزینه دریافت شده برای خرید حق اشتراک از مارکت‌های مذکوره و ارتباطی با سامانه هفتادسی نداره. 
              `,
            },
            {
              id: 63,
              question: `چرا پرداخت از طریق کد دستوری (USSD) یا (#7030*) ندارید؟`,
              answer: `بنا بر نظر قاطع کارشناسان و فعالان حوزه پرداخت USSD یک سامانه منسوخ قدیمی و نا امنه که به طرز استثنایی و عجیبی به خاطر انحصارهایی که وجود داره در ایران به این میزان استفاده میشه.برای جلوگیری از مشکلات و نا امنی‌های احتمالی این نحوه‌ی پرداخت برای کاربران ، هفتادسی فقط در بستر سایت، اپلیکیشن اندروید و آی او اس فعالیت می‌کنه.`,
            },
          ],
        },
        {
          show: false,
          id: 13,
          name: "سوالات عمومی",
          questionArray: [
            {
              id: 65,
              question: `<hr/>7030 چیست؟`,
              answer: `هفتادسی یک سامانه جامع، به روز، و امنِ پرداخته  که در حوزه فروش محصولات اعتباری و خدمات پرداخت بر بستر وبسایت به آدرس 7030.ir و اپلیکیشن اندروید و آی او اس محصولاتی از قبیل شارژ، بسته‌های اینترنت، استعلام و پرداخت انواع قبض، انتقال وجه کارت به کارت، نیکوکاری و انواع بیمه نامه رو به بیش از یک میلیون نفر از کاربران خود ارائه میده .این سامانه توسط شرکت « خلاق افق رویداد » متشکل از فارغ التحصیلان دانشگاه صنعتی شریف طراحی، تولید و راه‌اندازی شده. اونچه که هفتادسی رو از نمونه‌های مشابه متمایز میکنه علاوه بر کیفیت بالای ارائه‌ی خدمات، تخصیص 70 % درصد از سود تراکنش‌ها به کاربران و معرفان هفتادسیه.`,
            },
            {
              id: 66,
              question: `هفتادسی دقیقاً چطور کار میکنه؟`,
              answer: `هفتادسی خدماتش رو در قالب وب سایت و اپلیکیشن ارائه داده و مدل تبلیغات و بازاریابی اون برپایه‌ی شبکه‌های اجتماعی و مکانیزم‌های طبیعی بازاره، به این صورت که هزینه تبلیغات به جای استفاده در روش‌های متداول و سنتی مانند تلویزیون، بنر، بیلبورد و … از طریق دعوت کاربران جدید توسط کابران فعلی و تخصیص سود به معرفان و تبلیغ کنندگان انجام میشه. هفتادسی، ۷۰% از سودش رو به کاربران، فعالان و معرفان اختصاص میده.`,
            },
            {
              id: 67,
              question: `هفتادسی مناسب چه کسانی است؟`,
              answer: `در وهله‌ی اول هفتادسی مناسب تمام کسانیه که با شبکه های اجتماعی سروکار دارند و با کامپیوتر شخصی و یا گوشی هوشمند خود به دنبال دریافت خدمات اعتباری از قبیل خرید شارژ، پرداخت قبض و … هستن. در وهله‌ی دوم و به طور خاص مناسب کسانیه که قابلیت و توان جذب افراد و نیز روابط عمومی بالایی در معرفی هفتادسی به دوستانشون و ترغیب اون ها به استفاده از این خدمات دارن. از جمله مدیران وبلاگ‌ها، کانال‌های تلگرامی و هر شخصی که شبکه مخاطبین گسترده‌ای داره.`,
            },
            {
              id: 68,
              question: `هفتادسی چه مزیت‌هایی داره؟ `,
              answer: `1. برطرف‌ سازی عمده‌ی نیازهای روزمره و متداول کاربران در یک فضای یکپارچه، رابط کاربری مدرن و تجربه‌ی کاربری خوشایند و با استاندارد بالا
              <br/>2.ایجاد یک هاب و مرکز فروش برای تولیدکنندگان، توزیع کنند‌گان و فروشندگان خدمات اعتباری و کاهش هزینه های فروش و بازاریابی اون‌ها
              <br/>3. استفاده از روش‌های به روز، موثر و کم ‌هزینه تبلیغاتی و اتخاذ استراتژی بازاریابی بر روی شبکه اجتماعی و ایجاد باشگاه مشتریان و ایجاد مشوق‌ها برای توسعه‌ی بازار توسط مشتریان
              `,
            },
            {
              id: 69,
              question: `پشتیبانی خدمات سایت چطور انجام میشه؟`,
              answer: `پشتیبانی همه روزه (حتی در روزهای تعطیل)  از ساعت 9 الی 23 از طریق    <a target=_blank href="https://7030.ir/support" class="colorSecondary"> سامانه پشتیبانی </a> یا گزینه ی پشتیبانی در اپلیکیشن به صورت گفتگوی آنلاین(چت)انجام میشه.پیگیری تراکنش‌ها و ارائه ی بعضی از توضیحات و مدارک از طریق چت سریع تر و راحت تر قابل انجامه و نیازی نیست تا کاربر مدت زمان زیادی منتظر ارتباط تلفنی با پشتیبان باشه.سعی بر اینه که در اسرع وقت (زیر 5 دقیقه) به سوالات کاربران پاسخ داده بشه`,
            },
            {
              id: 70,
              question: `پس از نصب اپلیکیشن دلیل دسترسی‌هایی که خواسته شده چیه؟`,
              answer: `دسترسی‌هایی که در اپلیکیشن خواسته شده، برای کاربردهاییه که در اپلیکیشن داره؛ مثلا دسترسی مخاطبین به این جهته که کاربر شماره موبایلی که برای اون قصد خرید داره رو بدون حفظ کردن انتخاب کنه. دسترسی دوربین برای اسکن بارکد جهت پرداخت قبضه و همینطور دسترسی‌های دیگه هم به همین ترتیب برای کاربردیه که در اپلیکیشن جهت افزایش سرعت و راحتی کار دارن؛ لازم به ذکره که محافظت از اطلاعات کاربران وظیفه ماست.`,
            },
          ],
        },
      ],
      query: "",
    };
  },
  components: {},
  methods: {
    getFaq() {
      return this.searchResult;
    },
    toggle(obj) {
      // for (let i = 0; i < this.searchResult.length; i++) {
      //   if (this.searchResult[i].id != obj.id) {
      //     this.searchResult[i].show = false;
      //   }
      // }
      obj.show = !obj.show;
    },
    ...mapActions(["login", "openModal", "closeModal", "reOpenModal"]),
  },
  watch: {
    query: function () {
      const faq = [
                {
          show: false,
          id: 1,
          name: "ثبت نام و عضویت",
          questionArray: [
            {
              id: 1,
              question: `چطور ثبت نام کنم؟ مراحل ثبت نام رو توضیح بدید.`,
              answer: `
                1- در قسمت "ثبت نام" شماره موبایلتون رو وارد کنید..
                <br/>
                2- رمز عبور دلخواهتون رو ثبت کرده و به خاطر بسپارید.
                <br/>
                3-  اگر کسی سامانه هفتادسی رو به شما معرفی کرده شناسه‌ی دعوتش رو در قسمت مربوطه وارد کنید.
                <br/>
                4- پس از دریافت پیامک حاوی کد فعالسازی، اون رو در کادر مربوطه وارد کنید.
                                `,
            },
            {
              id: 2,
              question: `چرا کد فعالسازی (کد تایید) ارسال نمیشه؟`,
              answer: `
              گاهی ممکنه کد فعالسازی با تاخیر به دست شما برسه؛ اگر کد فعالسازی رو دریافت نکردید و یا دریافت کردید و اشتباه بود، ابتدا عدد 1 رو به سامانه 10000070307030 ارسال و سپس از قسمت "ورود" وارد برنامه بشید. در صورتی که مشکل برطرف نشد، با واحد پشتیبانی ارتباط برقرار کنید.
                                `,
            },
            {
              id: 3,
              question: `شناسه دعوت رو در کدوم قسمت وارد کنم؟`,
              answer: `هنگام ثبت نام، بعد از وارد کردن شماره موبایل و رمز عبور، قسمت مربوط به وارد کردن شناسه دعوت نشون داده میشه، اگر از قبل اون قسمت با یک شناسه­ دعوت پُر شده، یعنی شما از طریق لینکی که حاوی شناسه دعوت بوده وارد شده‌اید.`,
            },
            {
              id: 4,
              question: `آیا پس از ثبت نام میتونم شناسه‌ای که با اون دعوت شده‌­ام رو عوض کنم؟`,
              answer: `خیر؛ به خاطر قدردانی از زحمات کسی که شما رو با سامانه هفتادسی آشنا کرده امکان تغییر شناسه دعوت پس از ثبت نام به هیچ عنوان وجود نداره؛ می‌تونید با یک شماره موبایل دیگه مجدداً ثبت نام کنید و شناسه دعوت درست رو وارد کنید.`,
            },
            {
              id: 5,
              question: `رمز ورود رو فراموش کرده‌ام، چطور اون رو بازیابی کنم؟`,
              answer: `در قسمت "ورود" از گزینه‌ی " کلمه عبور را فراموش کرده‌ام" استفاده کنید.`,
            },
            {
              id: 6,
              question: `چطور میشه با دو سیم کارت ثبت نام کرد؟`,
              answer: `پس از ثبت نام با سیم کارت اول، می‌تونید از بخش پروفایل/سه نقطه‌ی بالای صفحه در سمت چپ، گزینه خروج رو بزنید، سپس با سیم کارت جدید ثبت نام بفرمایید.`,
            },
            {
              id: 7,
              question: `میشه با چند نام و شناسه فعالیت کرد؟`,
              answer: `بله؛ شما با هر شماره موبایل می‌تونید یک حساب کاربری داشته باشید، با هر حساب کاربری هم با لحاظ جمیع شرایط، می‌تونید تا سقف 5 شناسه دعوت که معرف اسم، اسم کانال یا صفحه، نام کسب و کار یا برند شماست، ثبت کرده و با اون ها به فعالیت و جذب مدعو بپردازید.`
                
                },
            {
              id: 8,
              question: `خودم با هفتادسی آشنا شده‌ام و کسی سامانه رو بهم معرفی نکرده، شناسه دعوت برای ثبت نام ندارم چکار کنم؟`,
              answer: `در صورتی که قصد ثبت نام با شناسه دعوت دارید می‌تونید شناسه‌ی دعوت هفتادسی، ir_7030  رو وارد کنید؛ لازمه بدونید که تفاوتی بین شناسه‌ها از نظر سوددهی وجود نداره`,
            },
            {
              id: 9,
              question: `چطور شماره موبایلی که با اون ثبت  نام کردم یا حساب کاربری خودم رو  به طور کامل حذف یا لغو عضویت کنم؟`,
              answer: `در هفتادسی هر کاربر با شماره موبایلی که ثبت نام میکنه شناخته میشه. از اونجا که در هفتادسی تراکنش مالی انجام میشه و طبق قوانین تجارت الکترونیک کشور این تراکنش‌ها باید ثبت و ذخیره بشن، امکان حذف کامل حساب کاربری یا شماره موبایل وجود نداره.`,
            },
          ],
        },
        {
          show: false,
          id: 2,
          name: "دعوت دوستان و جذب مدعو",
          questionArray: [
            {
              id: 8,
              question: `آیا محدودیت دعوت وجود داره؟ `,
              answer: `هیچ محدودیتی در تعداد دعوت وجود نداره و شما می‌تونید با کد معرفتون به تعداد نامحدود مدعو داشته باشید.`,
            },
            {
              id: 9,
              question: `ایجاد شناسه دعوت و معرفی دیگران چطور انجام میشه؟`,
              answer: `پس از ثبت نام، شماره موبایل شما به صورت پیش فرض به عنوان شناسه دعوت شناخته میشه؛ برای ساخت شناسه‌هایی غیر از  شماره موبایل، در اپلیکیشن با در نظر گرفتن جمیع شرایط از قسمت "پروفایل / کسب درآمد" گزینه‌ی "ساخت شناسه جدید" رو انتخاب بفرمایید. در نسخه سایت هم در قسمت " شناسه‌ها و مدعوین "  با کلیک بر روی گزینه "افزودن شناسه جدید" شناسه‌های دلخواهتون رو ایجاد و با "فرستادن دعوتنامه" اون‌ها رو منتشر کنید.`,
            },
            {
              id: 10,
              question: `افرادی که معرفی کردم یا تعداد مدعوین رو  از کجا میتونم ببینم؟`,
              answer: `در اپلیکیشن از مسیر پروفایل/کسب درآمد، با کلیک روی هر یک از شناسه‌ها، تعداد مدعوین اون شناسه و بخشی از شماره موبایلشون نمایش داده میشه.`,
            },
            {
              id: 11,
              question: `سود دریافتی از هفتادسی رو از کجا میتونم ببینم؟`,
              answer: `در اپلیکیشن از مسیر پروفایل/کسب درآمد، روی گزینه‌ی "جزییات حساب" کلیک کنید، سود دریافتی از تراکنش های خودتون و مدعوینتون نشون داده میشه.`,
            },
            {
              id: 12,
              question: `چرا هر شناسه‌ای می‌خواهم بسازم قبول نمی‌کنه، ساخت شناسه دعوت چه شرایطی داره؟`,
              answer: `شناسه‌ای که می‌سازید باید شرایط زیر رو داشته باشه:
              <br/>
                1. از کاراکترها و اعداد انگلیسی در شناسه استفاده بشه
              <br/>
                2.از قبل توسط شخص دیگه‌ای انتخاب نشده باشه
              <br/>
                3.حدقل 5 کاراکتر(عدد یا حرف) داشته باشه
              <br/>
                4.بین کاراکترها فقط از علامت (_) میشه استفاده کرد
              `,
            },
            {
              id: 13,
              question: `چطور شناسه‌هایی که ساختیم رو حذف کنیم  و  بعد از  حذف، وضعیت مدعوین اون شناسه چطور میشه؟`,
              answer: `با کلیک روی هر شناسه دعوت در قسمت "کسب درآمد" امکان حذف اون فراهم شده ولی در صورتی که بعد از حذف، اون شناسه توسط شخص دیگه‌ای رزرو بشه ، امکان بازپس‌گیری اون وجود نخواهد داشت. بعد از حذف شناسه، مدعوین اون شناسه در قسمت "مدعوین شناسه‌های حذف شده" قابل مشاهده است.`,
            },
            {
              id: 14,
              question: `جهت تبلیغات و آموزش به افراد دعوت شده مطالب و تصاویر گرافیکی آماده دارید؟`,
              answer: `بله؛ برای دسترسی به این موارد می‌تونید در کانال تلگرام ما با آی-دی:  ir_7030   ، کلمه‌ی "متریال" رو جستجو کنید.`,
            },
            {
              id: 15,
              question: `چرا در اینستاگرام نمیشه لینک هفتادسی رو به اشتراک گذاشت؟`,
              answer: `به دليل استفاده بسیار زیاد كاربران و دعوت‌كنندگان از لينک سايت هفتادسی متاسفانه اينستاگرام اين لينك رو به عنوان لينك اسپم شناسايی كرده و از انتشار اون جلوگيری میكنه. تا رفع این مشکل كاربران عزيز میتونن برای اشتراك كد معرفشون فقط از شناسه معرف(بدون قرار دادن لینک هفتادسی در متن) استفاده کنن.همچنین تصاویر و بنرهای مناسبی برای تبلیغ در اینستاگرام فراهم شده که در کانال تلگرام(با عنوان متریال) می‌تونید پیداشون کنید.`,
            },
          ],
        },
        {
          show: false,
          id: 3,
          name: "درآمدزایی از هفتادسی",
          questionArray: [
            {
              id: 17,
              question: `چگونه درآمدزایی کنم؟`,
              answer: `درآمدزایی از طریق جذب کاربران و سهیم شدن در سود تراکنش‌هاشون ایجاد میشه. هر تراکنشی که شما یا مدعوین شما (کاربرانی که با شناسه دعوت شما ثبت نام کردن) انجام میدید، سود مشخصی داره که به اعتبار شما در سامانه اضافه میشه. شما می‌تونید این اعتبار رو برداشت یا با اون خرید انجام بدید. طبیعتاً تعداد مدعوین بیشتر و به دنبالش افزایش تراکنش‌ها، درآمد بیشتری برای شما در پی خواهد داشت.`,
            },
            {
              id: 18,
              question: `درآمد من چطور پرداخت میشه؟`,
              answer: `سود تراکنش‌ها با واحد "تومان" به اعتبار شما در سامانه اضافه میشه و جهت برداشتش هر زمان که تمایل داشته باشید، می‌تونید در قسمت "پروفایل / اعتبار" مراحل درخواست واریز رو انجام بدید.1- مبلغ نهایتا تا 3 روزکاری (3 روز غیر تعطیل) به حساب شما واریز میشه. 2- حداقل مبلغ قابل واریز  10000 تومانه`,
            },
            {
              id: 19,
              question: `چرا به شماره شبا نیازه؟ چطور میشه شماره شبا رو  دریافت کرد؟`,
              answer: `شبا(شناسه بانکی ایران)متشکل از 24 رقمه و روی بعضی از کارت‌های بانکی درج شده؛ شبا رو به دو طریق میشه به دست آورد:
              <br/>
               1- مراجعه حضوری به بانک یا عابر بانک مربوطه
               <br/>
               2. دریافت اون از طریق وبسایت بانک مربوطه`,
            },
            {
              id: 20,
              question: `طرح درآمدی (پلن درآمدی) به چه صورته؟`,
              answer: `هفتادسی، هفتاد درصد از سود خالص فروش محصولات رو به کاربران اختصاص داده و  این سود با در نظر گرفتن محدویت‌ها و الزامات قانونی در یک سطح تقسیم میشه. به عبارتی از هفتاد درصد سودی که کاربران از فروش هر محصول میبرن، ۴۰ درصد به معرف و ۳۰ درصد مابقی به خریدار تعلق میگیره. تلاش شده که تقسیم سود متناسب با زحمت کاربران در تبلیغ و معرفی سامانه باشه. لطفا به تبلیغات و محتواهای متنی و ویدئویی که برپایه‌ی سوددهی چندسطحی،درآمد ثابت ماهانه  و ... منتشر میشه توجه نفرمایید و معیارتون رو قوانین و مقررات سایت هفتادسی قرار بدید. مادامی که قانون فروش و بازاریابی شبکه‌ای برای محصولات و خدماتی که هفتادسی ارائه می‌کنه، ابلاغ و توسط نهادهای دولتی اجرایی نشه، هفتادسی نمیتونه به صورت چند سطحی سوددهی انجام بده. هرگونه تغییر درباره‌ی نحوه‌ی سوددهی از طریق رسانه‌های رسمی سامانه اطلاع رسانی خواهد شد.`,
            },
            {
              id: 21,
              question: `میزان دقیق سود هر خرید چقدره؟`,
              answer: `
              مقدار سود هر محصول بستگی به قیمتش و شرکتی که اون رو برای ما تامین میکنه و با اون قرارداد منعقد کرده‌ایم، داره:
              <br/>
              ✅تمام سود فروش هر کد شارژ : 2.3 درصد از مبلغ کل محصول
              <br/>
             ✅تمام سود فروش شارژ مستقیم ایرانسل: 2.9 درصد از مبلغ کل محصول
              <br/>
             ✅تمام سود فروش شارژ مستقیم رایتل: 3.2 درصد از مبلغ کل محصول
              <br/>
             ✅تمام سود فروش شارژ مستقیم همراه اول: 2.3 درصد از مبلغ کل محصول
              <br/>
              ✅تمام سود فروش بسته های اینترنت ایرانسل 2.9 درصد و بسته های اینترنت سایر اپراتورها 3.2 درصد از مبلغ کل محصوله
              <br/>
             یعنی مثلا تمام سود یک شارژ مستقیم ۱۰ هزار تومانی ایرانسل 290 تومان، کل سود شارژ  ۱۰ هزار تومانی رایتل، 320 تومان و کل سود یک شارژ ۱۰ هزار تومانی همراه اول 230 تومانه که 40 درصد اون سهم معرف و 30 درصدش سهم خریداره
              <br/>
              ✅سرویس انتقال وجه در حال حاضر مستقیما توسط درگاه بانکی انجام شده و به سامانه هفتادسی سودی پرداخت نمیشه ؛ با بالا رفتن حجم تراکنش‌ها، میتونیم با درگاه بانکی جهت دریافت سود، مذاکره و در صورتی که سودی پرداخت بشه حتما برای کاربران نیز در نظر گرفته و اطلاع رسانی خواهد شد.
              <br/>

                            `,            },
            {
              id: 22,
              question: `با توجه به سود کم محصولاتی مثل شارژ و بسته‌ی اینترنت، ارزش داره وقتمون رو صرف این کار کنیم؟`,
              answer: `بله؛ در بازار فعلی سود فروش شارژ سیم کارت‌های اعتباری حدود ۶۰ میلیارد تومان در ماه و در سال حدود ۷۲۰ میلیارد تومان هست، که اگر ما بتونیم حتی یک درصد از بازار شارژ رو پوشش بدیم، در سال مبلغ ۷.۲ میلیارد تومان سود خواهیم داشت که ۷۰% از این مبلغ یعنی، ۵ میلیارد تومان به کاربران تعلق داره . ضمن اینکه سایر محصولات ارائه شده در سامانه هم (پرداخت‌ قبض، بسته‌های اینترنتی، خرید بیمه) هر کدوم سود مختص به خودشون رو دارن که اون هم رقم قابل توجهی خواهد بود.`,
            },
            {
              id: 23,
              question: `چه تضمینی وجود داره که همیشه 70 درصد از سودتون رو به کاربران پرداخت کنید؟`,
              answer: `اساساً هدف اصلی هفتادسی از ابتدای تاسیس این بوده که به جای هزینه‌های گزاف تبلیغات تلویزیونی و ...، این مبالغ رو به عنوان سود تراکنش‌ها و پاداش فعالیت به کاربران هدیه کنه؛ همونطور که از اسم هفتادسی هم پیداست 70 درصد از سود تراکنش همواره به کاربران تقدیم میشه؛ قطعا بزرگترین سرمایه هفتادسی کاربران فعال هستن و باید رضایت اون‌ها حاصل بشه.`,
            },
          ],
        },
        {
          show: false,
          id: 4,
          name: "برداشت وجه و افزایش اعتبار",
          questionArray: [
            {
              id: 25,
              question: `چرا با اینکه درآمدم از هفتادسی بیشتر از ده هزار تومانه، نمی‌تونم درخواست واریز ثبت کنم و خطای کمبود اعتبار میده؟`,
              answer: `"درآمد از هفتادسی" میزان درآمدیه که شما از ابتدای عضویت در سامانه کسب کردید و جنبه‌ی اطلاع رسانی داره ؛ ثبت درخواست واریز وجه و یا خرید محصول بر مبنای "اعتبار فعلی" انجام میشه؛ اگر سابقاً هیچ خریدی با اعتبار انجام نداده باشید، میزان "اعتبار فعلی" و "درآمد از هفتادسی" شما یکسان خواهد بود، در غیر اینصورت اعتبار فعلی کمتر از درآمد از هفتادسی نشون داده میشه. نکته: تمامی مبالغ و ارقام در هفتادسی بر اساس واحد "تومان" نشون داده میشن.
              `,
            },
            {
              id: 26,
              question: `درخواست واریز زدم، چرا مبلغ رو از اعتبار من کم کرده ولی به حساب بانکی من واریز نشد؟`,
              answer: `زمانی که درخواست واریز ثبت می‌کنید، مبلغ از اعتبار شما خارج شده و در صف واریز قرار میگیره، (به اصطلاح hold میشه) تا از طریق امور مالی، به حساب شما حواله‌ی پایا بشه؛ این فرآیند ممکنه از 1 تا 3 روز کاری زمانبر باشه.`,
            },
            {
              id: 27,
              question: `برای برداشت مبلغی که خودم افزایش اعتبار داده ام چه کاری باید انجام بدم؟`,
              answer: `افزایش اعتبار برای تسهیل فرآیند خرید بوده و اساساً امکان برداشت این دسته از مبالغ وجود نداره؛ در موارد اضطراری و بنا به صلاحدید واحد مالی، طبق دستورالعمل های ابلاغ شده از مراجع قانونی مبلغ فقط به کارتی که افزایش اعتبار با اون انجام شده عودت میشه و همچنین اطلاعات هویتی صاحب کارت باید به شرح زیر دریافت بشه:
              <br/>
              1. تصویر کارتی که افزایش اعتبار با اون انجام شده (جهت حفظ امنیت بیشتر تاریخ انقضا و CVV2 پوشانده بشه) 
              <br/>
              2. تصویر کارت ملی صاحب کارت
              <br/>
              3. یک برگه که روی اون شماره موبایل کاربری، تاریخ، امضا و شماره شبای کارت مورد نظر نوشته شده باشه
          لازم به ذکره که هر سه مورد حتما باید در یک عکس قرار گرفته باشن.
              `,
            },
          ],
        },
        {
          show: false,
          id: 5,
          name: "خرید شارژ و بسته اینترنت",
          questionArray: [
            {
              id: 28,
              question: `آیا قیمت های محصولات شما از جاهای دیگه بیشتره؟`,
              answer: `کد شارژهایی که خریداری می نمایید در بخش تراکنشها قرار میگیرن، دراین بخش روی تراکنش مربوطه کلیک کنید، کد شارژ شما قابل مشاهده و استفاده است.؛`,
            },
            {
              id: 29,
              question: `کد شارژ خریدم، کجا میتونم ببینم و استفاده کنم؟`,
              answer: `کد شارژهای خریداری شده، هم در بخش تراکنش‌ها و هم در بخش پیام‌های برنامه ثبت میشن و هم اینکه به شماره موبایل کاربری تون پیامک میشن.`,
            },
            {
              id: 30,
              question: ` برای خرید بیش از سقف تعیین شده در روز چه کاری باید انجام داد؟`,
              answer: `خرید هر چه بیشتر کاربران باعث خرسندی ماست؛ ولی برای حفظ امنیت کاربران و رعایت قوانین تجارت الکترونیک، افزایش اعتبار و یا خرید بیش از سقف تعیین شده، نیاز به احراز هویت حساب کاربر و کارتی که با اون پرداخت میشه هست. لازمه اطلاعات هویتی صاحب حساب کاربری به شرح زیر دریافت بشه:
              <br/>
               1. تصویر کارتی که افزایش اعتبار با اون انجام شده (جهت حفظ امنیت بیشتر تاریخ انقضا و CVV2 پوشانده بشه) 
               <br/>
              2. تصویر کارت ملی صاحب کارت
               <br/>
               3. یک برگه که روی آن شماره موبایل کاربری و تاریخ روز نوشته شده باشه؛ لازم به ذکره که هر 3 مورد باید در یک عکس قرار گرفته باشن`,
            },
            {
              id: 31,
              question: `آیا شارژ یا بسته اینترنت خریداری شده ، پس از فعال شدن امکان بازگشت داره؟`,
              answer: `خیر؛ از اونجایی که شارژ و بسته اینترنت مستقیما از سمت اپراتور بر روی خط شما فعال میشه، به هیچ وجه از سمت ما قابل بازگشت نیست.`,
            },
          ],
        },
        {
          show: false,
          id: 6,
          name: " پرداخت قبض",
          questionArray: [
            {
              id: 32,
              question: `پرداخت قبض انجام دادم که ناموفقه ولی پول از حسابم کسر شده، چکار کنم؟`,
              answer: `گاهی اوقات پرداخت قبوض به اشتباه پرداخت نشده نمایش داده میشن ، درصورتی که پرداخت موفق بوده (دلیلش عدم پاسخ دهی بانک در اون لحظه به ما هست). درنتیجه همکاران به صورت دوره ای پرداخت قبض هایی که ناموفق اعلام شده اند رو بررسی مجدد کرده و ایراد رو برطرف می کنند، در این خصوص جای هیچ نگرانی نیست و سود تمام تراکنش های شما لحاظ خواهد شد. لطفا کد پیگیری (شماره مرجع) 12 رقمی تراکنش، یا شماره کارتی که با اون پرداخت نموده اید رو به پشتیبانی سامانه ارسال کنید تا پیگیری های لازم از درگاه بانکی انجام بشه.`,
            },
            {
              id: 33,
              question: `آیا پرداخت قبض و یا انتقال وجه با اعتبار درون برنامه ای هفتادسی امکان پذیره؟`,
              answer: `خیر، به دلیل اینکه پرداخت قبض و انتقال وجه عملیات بانکی محسوب میشه و قبوض رو بانک با سازمان صادر کننده ی اون تسویه می‌کنه این عملیات فقط از طریق درگاه بانکی قابل انجامه و با اعتبار درون برنامه‌ای هفتادسی امکان پرداخت ندارن. برای خرید محصولات اعتباری می‌تونید از اعتبارتون استفاده بفرمایید.`,
            },
            {
              id: 34,
              question: `قبض پرداخت کردم، چقدر زمان می بره تا بدهی من در سازمان مربوطه صفر بشه؟`,
              answer: `تسویه حساب بانک با سازمان ها معمولا هر روز کاری(غیر تعطیل) انجام میشه، ولی زمان بروزرسانی در سازمان‌ها و صفر کردن بدهی متفاوته، بعضی سازمان‌ها سریع و بعضی کندتر عمل میکنن، به عنوان مثال تسویه قبوض جرائم راهنمایی و رانندگی با توجه به شرایط ویژه ناجا و عدم به روزرسانی روزانه سیستم پرداخت، گاهی اوقات تا 3 هفته زمان می‌بره. پیشنهاد می‌کنیم برای تسویه‌ی لحظه‌ای قبض ایرانسل سیم کارت مورد نظر رو از قسمت ویترین مستقیما شارژ کنید و برای تسویه‌ی لحظه‌ای قبض همراه اول، قبض رو از درگاه به پرداخت ملت پرداخت بفرمایید.`,
            },
          ],
        },
        {
          show: false,
          id: 7,
          name: "کارت به کارت",
          questionArray: [
            {
              id: 38,
              question: `با کارت چه بانک هایی میشه کارت به کارت کرد؟`,
              answer: `در حال حاضر با سه بانک پارسیان، انصار و توسعه تعاون به عنوان کارت مبدا میشه به هر بانک مقصدی انتقال وجه انجام داد. مجوزهای بانک‌های دیگه هم اخذ شده و به زودی در سامانه پیاده‌سازی و اجرا خواهند شد.`,
            },
            {
              id: 39,
              question: `سود کارت به کارت چطور محاسبه میشه؟`,
              answer: `سرویس کارت به کارت مستقیماً توسط درگاه بانکی انجام شده و بابتش به سامانه هفتادسی سودی پرداخت نمیشه. به زودی با بالا رفتن حجم تراکنش‌ها، میشه با درگاه بانکی جهت دریافت سود، مذاکره کرد.`,
            },
            {
              id: 40,
              question: `آیا از طریق سایت هم میشه کارت به کارت کرد؟`,
              answer: `خیر؛ کارت به کارت فقط از طریق اپلیکیشن امکان پذیره.`,
            },
            {
              id: 41,
              question: `تراکنش کارت به کارت انجام دادم ولی پول منتقل نشده، چطور میتونم پیگیری کنم؟`,
              answer: `با توجه به اینکه کارت به کارت، مستقیما از درگاه بانک پارسیان انجام میشه، پیگیری تراکنش توسط پشتیبانی درگاه با شماره تماس
 2318-021  قابل انجامه.`,
            },
          ],
        },
        {
          show: false,
          id: 8,
          name: "خرید بیمه",
          questionArray: [
            {
              id: 41,
              question: `چطور می‌تونم بیمه‌هایی که در سامانه ثبت نام کردم رو مشاهده کنم؟`,
              answer: `از قسمت "ویترین/بیمه/ خودرو/ بیمه های من" ، می‌تونید مشاهده کنید.`,
            },
            {
              id: 42,
              question: `چرا سود بیمه‌ای که خریدم به اعتبار کاربریم در سامانه اضافه نشده ؟`,
              answer: `تسویه‌ی سود بیمه نامه‌های خریداری شده ماهانه انجام میشه و در پایان هر ماه سود اون‌ها به اعتبار درون برنامه‌ای کاربران اضافه خواهد شد.`,
            },
          ],
        },
        // {
        //   show: false,
        //   id: 9,
        //   name: "خرید بلیط هواپیما",
        //   questionArray: [
        //     {
        //       id: 46,
        //       question: `میخوام یه بلیط بگیرم در برنامه هفتادسی نمیتونم پیداش کنم درحالی که در دیگر سامانه ها همون بلیط وجود داره؟`,
        //       answer: `چنین چیزی امکان نداره و در 99 درصد موارد با رفرش کردن برنامه تمام پروازها آپدیت خواهند شد.`,
        //     },
        //     {
        //       id: 47,
        //       question: `پروازم از طرف ایرلاین کنسل شده چطور میتونم پولمو بگیرم؟`,
        //       answer: `در سایت های هالیدی باید فرم استرداد رو پر کنید و مبلغ بلیط کنسل شده نیز به همون شماره کارت یا حسابی واریز میشه که در اون فرم وارد می کنید، مابه التفاوت مبلغ بلیط هم به اعتبار درون برنامه ایتون در سامانه،اضافه میشه.`,
        //     },
        //     {
        //       id: 48,
        //       question: `مشکلی پیش اومده و میخوام پروازم رو کنسل کنم، چه کار باید انجام دهم؟`,
        //       answer: `باید در سایت های هالیدی فرم استرداد بلیط پر کنید و بسته به نوع پرواز (سیستمی یا چارتر)، در صورتی که امکان کنسلی داشته باشه، مبلغ بلیط با احتساب جریمه، به شماره حساب یا کارت ثبت شده توسط شما، واریز خواهد شد.`,
        //     },
        //     {
        //       id: 49,
        //       question: `پس از دو ساعت از زمان پرواز، در فرودگاه به ما اعلام کردن که پروازتون کنسله، چطور میتونم پول بلطیمو بگیرم؟`,
        //       answer: `باید بلیطتون رو در دفتر ایرلاین مربوطه مهر بزنید و پس از تکیمل فرم استرداد در سایت های هالیدی، تصویر بلیط رو نیز در قسمت پشتیبانی برای ما بفرستین تا روند پیگیری اون انجام بشه.`,
        //     },
        //     {
        //       id: 50,
        //       question: `برام از طرف ایرلاین یا آژانس پیامک اومده که پروازم با دو ساعت تاخیر یا تعجیل همراهه، چطور میتونم پرواز رو کنسل و پولم رو بگیرم؟`,
        //       answer: `در صورتی که تاخیر یا تعجیل اعلام شده زیر دو ساعت باشه، مشروط به عدم تغییر شماره پرواز، امکان کنسل بلیط نیست اما در صورتی که بالای دو ساعت باشه، پس از تکیمل فرم استرداد در سایت های هالیدی و انعکاس موضوع به پشتیبانی سامانه، کل مبلغ بلیط عودت داده خواهد شد.`,
        //     },
        //   ],
        // },
        {
          show: false,
          id: 10,
          name: "درگاه بانکی و پرداخت",
          questionArray: [
            {
              id: 51,
              question: `آیا برای هر خرید باید تمام اطلاعات کارت بانکیمون (شماره کارت، تاریخ انقضاء و ...) رو وارد کنیم؟`,
              answer: `خیر؛ بعد از ورود به درگاه بانک، می‌تونید با فعال کردن تیکِ گزینه‌ی "ذخیره‌ی اطلاعات کارت"،شماره کارت و تاریخ انقضای اون رو در همون درگاه ذخیره کنید. همچنین برای خرید راحت‌تر  و سریع‌تر می‌تونید افزایش اعتبار بدید و بدون ورود به درگاه بانک و استفاده از کارت، مبلغ خریدتون رو از اعتبار پرداخت کنید.`,
            },
            {
              id: 52,
              question: `پیغام "تراکنش توسط دارنده کارت مجاز نیست" به چه علت دریافت میشه؟`,
              answer: `بعضی بانک‌ها برای بعضی از درگاه‌ها، محدودیت حداقل مبلغ تراکنش قرار داده‌اند، مثلا بانک ملت محدودیت حداقل مبلغ 10 هزار تومان یا بانک انصار  محدودیت حداقل 5 هزار تومن داره و تراکنش‌های کمتر از این مبلغ  رو نمی‌پذیره.چنین مواقعی برای استفاده از کارت بانک ملت می‌تونید از درگاه اینترنتی به پرداخت ملت اقدام بفرمایید. همچنین اگر قصد خرید دارید،می‌تونید با هر مبلغی افزایش اعتبار بدید و خریدهاتون رو با اعتبار پرداخت کنید.`,
            },
            {
              id: 53,
              question: `چرا بعضی پرداخت‌ها با مشکل مواجه می‌­شن؟`,
              answer: `گاهی اوقات ممکنه به دلایلی از جمله عدم پاسخ دهی آنی بانک و یا تامین کننده، برخی تراکنش‌ها با خطا مواجه بشن. در صورت کسر مبلغ از حسابتون، درگاه بانکی حداکثر تا 72 ساعت مبلغ کسر شده رو عودت میده. برای بررسی دقیقتر تراکنش هاتون می‌تونید شماره مرجع تراکنش یا شماره کارتی که با اون پرداخت رو انجام دادید برای همکاران ما در واحد پشتیبانی ارسال کنید تا پیگیری های لازم انجام بشه.`,
            },
            {
              id: 54,
              question: `علی‌رغم گذشت 72 ساعت از انجام تراکنش (ناموفق) هنوز مبلغش به حسابم برگشت نخورده، چه کاری باید انجام بدم؟`,
              answer: `گاهی اوقات پیامک اصلاح از  بانک ارسال نمیشه و یا مبلغ تراکنش ناموفق رو به همراه سود اون به حساب کاربر عودت میدن (حدود 1000 تومان)، به همین خاطر لازمه که گردش حساب بانکیتون رو بررسی کنید و از عودت یا عدم عودت مبلغ تراکنش مطمئن بشید، در صورتی که برنگشته باشه می‌تونید با واحد امداد شتاب با شماره 29911-021 تماس بگیرید و پیگیری بفرمایید.`,
            },
            {
              id: 55,
              question: `هفتادسی در تبلیغاتش ادعای خرید سریع و آسان می‌کنه، روش خرید سریع چطوره؟`,
              answer: `سریعترین روش خرید، پرداخت با اعتباره .کاربر میتونه از طریق درآمدی که از هفتادسی کسب کرده و یا با افزایش اعتبار درون برنامه‌ای به میزان مورد نیاز برای خریدهایی که قراره انجام بده، فقط با یک کلیک پرداخت کنه.`,
            },
          ],
        },
        {
          show: false,
          id: 11,
          name: "امنیت و مجوزها",
          questionArray: [
            {
              id: 56,
              question: `هنگام پرداخت چگونه به هفتادسی اعتماد و اطلاعات کارتمون رو وارد کنیم؟`,
              answer: `همه‌ی پرداخت‌ها مستقیماً از طریق درگاه بانکی انجام میشن؛ تمامی اطلاعاتی که در زمان پرداخت وارد می‌کنید، فقط در درگاه بانکی وارد شده و به هیچ‌ عنوان در هفتادسی ثبت یا ذخیره نخواهند شد.`,
            },
            {
              id: 57,
              question: `آیا سیستم هفتادسی امن و قابل اطمینانه؟`,
              answer: `بله؛ هفتادسی با استانداردها و تکنولوژی روز و امنیت بالا طراحی و پیاده سازی شده و در پرداخت‌ها هم از درگاه‌های امن بانکی استفاده میکنه. هفتادسی صرفاً یک واسطه و رابط بین فروشنده و خریدار هست و اطلاعات بانکی حساب شما به هیچ وجه در سرورهای هفتادسی ذخیره نمیشن .`,
            },
            {
              id: 58,
              question: `مجوز های 7030 را از کجا میتوان مشاهده کرد؟`,
              answer: `در لینک زیر مجوزهای سایت را میتونید مشاهده کنید؛ https://7030.ir/enemad همچنین میتونید به سایت enamad.ir مراجعه کنید و در قسمت استعلام، با وارد کردن آدرس: 7030.ir نتیجه را مشاهده بفرمایید؛`,
            },
            {
              id: 59,
              question: `آیا هفتادسی قانونیه؟`,
              answer: `بله؛ اختصاص سود به بازاریابان در همه‌ی کسب و کارها مرسوم بوده و در حال انجامه. سایت هفتادسی مجوزهای نظارت بر کسب و کارهای دیجیتال وزارت صنعت، معدن و تجارت (Enamad)، مجوز مرکز ساماندهی رسانه‌های دیجیتال وزارت ارشاد و مجوز انجمن صنفی کسب و کار اینترنتی و گواهی ارزیابی امنیتی رو دریافت کرده.`,
            },
            {
              id:60,
              question:`مجوز های هفتادسی رو  از کجا میشه مشاهده کرد؟`,
              answer:`مجوزهای قانونی و امنیتی هفتادسی رو می‌تونید از   <a target=_blank href="https://7030.ir/enamad" class="colorSecondary">اینجا </a>مشاهده کنید.همچنین برای مشاهده ی نماد اعتماد الکترونیکی می‌تونید به سایت enamad.ir مراجعه و در قسمت استعلام، با وارد کردن آدرس   7030.ir  نتیجه رو ببینید.`
            }
          ],
        },
        {
          show: false,
          id: 12,
          name: "دانلود اپلیکیشن، آپدیت‌ها و برنامه‌های آینده",
          questionArray: [
            {
              id: 60,
              question: `چطور میتونم اپلیکیشن رو دانلود یا بروزرسانی کنم؟`,
              answer: `از طریق لینک زیر می‌تونید نسخه متناسب با گوشیتون رو از مارکت‌های معتبر دانلود یا بروزرسانی بفرمایید:
              <br/>
              <a target=_blank href="https://7030.ir/download" class="colorSecondary">لینک دانلود اپلیکشن </a>`,
            },
            {
              id: 61,
              question: `روش دانلود اپلیکیشن در گوشی‌های آیفون چطوره؟`,
              answer: `به دلیل محدودیت های اعمال شده از سوی اپل برای اپلیکیشن‌های ایرانی، در حال حاضر نسخه "آی او اس" برنامه  در مارکت های سیبچه، سیب ایرانی، اناردونی و آی اپس قابل دانلوده.
              <br/><a target="_blank" href="https://sibche.com/applications/7030-1" class="colorSecondary"> دانلود از سیبچه  </a>
              <br/><a target=_blank href="https://anardoni.com/ios/app/2qr0XbRxg?lng=fa" class="colorSecondary"> دانلود از اناردونی </a>
              <br/><a target="_blank" href="https://sibirani.ir/apps/%D9%87%D9%81%D8%AA%D8%A7%D8%AF%D8%B3%DB%8C-7030/" class="colorSecondary"> دانلود از سیب ایرانی  </a>
              <br/><a target="_blank" href="https://iapps.ir/app/%D9%87%D9%81%D8%AA%D8%A7%D8%AF%D8%B3%DB%8C-7030/509472634" class="colorSecondary"> دانلود از آی اپس  </a>
              `,
            },
            {
              id: 62,
              question: `چرا برای دانلود نسخه آی او اس هفتادسی از مارکت هایی مثل سیبچه و ... باید پول پرداخت کنیم؟`,
              answer: `هزینه دریافت شده برای خرید حق اشتراک از مارکت‌های مذکوره و ارتباطی با سامانه هفتادسی نداره. 
              `,
            },
            {
              id: 63,
              question: `چرا پرداخت از طریق کد دستوری (USSD) یا (#7030*) ندارید؟`,
              answer: `بنا بر نظر قاطع کارشناسان و فعالان حوزه پرداخت USSD یک سامانه منسوخ قدیمی و نا امنه که به طرز استثنایی و عجیبی به خاطر انحصارهایی که وجود داره در ایران به این میزان استفاده میشه.برای جلوگیری از مشکلات و نا امنی‌های احتمالی این نحوه‌ی پرداخت برای کاربران ، هفتادسی فقط در بستر سایت، اپلیکیشن اندروید و آی او اس فعالیت می‌کنه.`,
            },
          ],
        },
        {
          show: false,
          id: 13,
          name: "سوالات عمومی",
          questionArray: [
            {
              id: 65,
              question: `7030 چیست؟`,
              answer: `هفتادسی یک سامانه جامع، به روز، و امنِ پرداخته  که در حوزه فروش محصولات اعتباری و خدمات پرداخت بر بستر وبسایت به آدرس 7030.ir و اپلیکیشن اندروید و آی او اس محصولاتی از قبیل شارژ، بسته‌های اینترنت، استعلام و پرداخت انواع قبض، انتقال وجه کارت به کارت، نیکوکاری و انواع بیمه نامه رو به بیش از یک میلیون نفر از کاربران خود ارائه میده .این سامانه توسط شرکت « خلاق افق رویداد » متشکل از فارغ التحصیلان دانشگاه صنعتی شریف طراحی، تولید و راه‌اندازی شده. اونچه که هفتادسی رو از نمونه‌های مشابه متمایز میکنه علاوه بر کیفیت بالای ارائه‌ی خدمات، تخصیص 70 % درصد از سود تراکنش‌ها به کاربران و معرفان هفتادسیه.`,
            },
            {
              id: 66,
              question: `هفتادسی دقیقاً چطور کار میکنه؟`,
              answer: `هفتادسی خدماتش رو در قالب وب سایت و اپلیکیشن ارائه داده و مدل تبلیغات و بازاریابی اون برپایه‌ی شبکه‌های اجتماعی و مکانیزم‌های طبیعی بازاره، به این صورت که هزینه تبلیغات به جای استفاده در روش‌های متداول و سنتی مانند تلویزیون، بنر، بیلبورد و … از طریق دعوت کاربران جدید توسط کابران فعلی و تخصیص سود به معرفان و تبلیغ کنندگان انجام میشه. هفتادسی، ۷۰% از سودش رو به کاربران، فعالان و معرفان اختصاص میده.`,
            },
            {
              id: 67,
              question: `هفتادسی مناسب چه کسانی است؟`,
              answer: `در وهله‌ی اول هفتادسی مناسب تمام کسانیه که با شبکه های اجتماعی سروکار دارند و با کامپیوتر شخصی و یا گوشی هوشمند خود به دنبال دریافت خدمات اعتباری از قبیل خرید شارژ، پرداخت قبض و … هستن. در وهله‌ی دوم و به طور خاص مناسب کسانیه که قابلیت و توان جذب افراد و نیز روابط عمومی بالایی در معرفی هفتادسی به دوستانشون و ترغیب اون ها به استفاده از این خدمات دارن. از جمله مدیران وبلاگ‌ها، کانال‌های تلگرامی و هر شخصی که شبکه مخاطبین گسترده‌ای داره.`,
            },
            {
              id: 68,
              question: `هفتادسی چه مزیت‌هایی داره؟ `,
              answer: `1. برطرف‌ سازی عمده‌ی نیازهای روزمره و متداول کاربران در یک فضای یکپارچه، رابط کاربری مدرن و تجربه‌ی کاربری خوشایند و با استاندارد بالا
              <br/>2.ایجاد یک هاب و مرکز فروش برای تولیدکنندگان، توزیع کنند‌گان و فروشندگان خدمات اعتباری و کاهش هزینه های فروش و بازاریابی اون‌ها
              <br/>3. استفاده از روش‌های به روز، موثر و کم ‌هزینه تبلیغاتی و اتخاذ استراتژی بازاریابی بر روی شبکه اجتماعی و ایجاد باشگاه مشتریان و ایجاد مشوق‌ها برای توسعه‌ی بازار توسط مشتریان
              `,
            },
            {
              id: 69,
              question: `پشتیبانی خدمات سایت چطور انجام میشه؟`,
              answer: `پشتیبانی همه روزه (حتی در روزهای تعطیل)  از ساعت 9 الی 23 از طریق    <a target=_blank href="https://7030.ir/support" class="colorSecondary"> سامانه پشتیبانی </a> یا گزینه ی پشتیبانی در اپلیکیشن به صورت گفتگوی آنلاین(چت)انجام میشه.پیگیری تراکنش‌ها و ارائه ی بعضی از توضیحات و مدارک از طریق چت سریع تر و راحت تر قابل انجامه و نیازی نیست تا کاربر مدت زمان زیادی منتظر ارتباط تلفنی با پشتیبان باشه.سعی بر اینه که در اسرع وقت (زیر 5 دقیقه) به سوالات کاربران پاسخ داده بشه`,
            },
            {
              id: 70,
              question: `پس از نصب اپلیکیشن دلیل دسترسی‌هایی که خواسته شده چیه؟`,
              answer: `دسترسی‌هایی که در اپلیکیشن خواسته شده، برای کاربردهاییه که در اپلیکیشن داره؛ مثلا دسترسی مخاطبین به این جهته که کاربر شماره موبایلی که برای اون قصد خرید داره رو بدون حفظ کردن انتخاب کنه. دسترسی دوربین برای اسکن بارکد جهت پرداخت قبضه و همینطور دسترسی‌های دیگه هم به همین ترتیب برای کاربردیه که در اپلیکیشن جهت افزایش سرعت و راحتی کار دارن؛ لازم به ذکره که محافظت از اطلاعات کاربران وظیفه ماست.`,
            },
          ],
        },
      ];
      var self = this;
      this.searchResult = faq;

      function searchQuestion(obj) {
        for (let Question in obj.questionArray) {
          if (
            obj.questionArray[Question].question.search(self.query) > -1 ||
            obj.questionArray[Question].answer.search(self.query) > -1
          ) {
            obj.show = true;
            return true;
          }
        }
      }

      function queryQuestion(question) {
        if (
          question.question.search(self.query) > -1 ||
          question.answer.search(self.query) > -1
        ) {
          question.question = highlight(question.question, self.query);
          return true;
        }
      }

      function highlight(question, text) {
        var inputText = question;
        var index = inputText.indexOf(text);
        if (index >= 0) {
          inputText =
            inputText.substring(0, index) +
            "<span class='highlight'>" +
            inputText.substring(index, index + text.length) +
            "</span>" +
            inputText.substring(index + text.length);
          return inputText;
        } else {
          inputText =
            inputText +
            '<span class="parantez"> (نتیجه جست و جو در پاسخ این سوال) </span>';
          return inputText;
        }
      }

      this.searchResult = this.searchResult.filter(searchQuestion);
      for (let obj in this.searchResult) {
        this.searchResult[obj].questionArray = this.searchResult[
          obj
        ].questionArray.filter(queryQuestion);
      }
    },
  },
  mounted() {
    if (this.$route.hash) {
      setTimeout(() => {
        for (let obj in this.searchResult) {
          for (let i in this.searchResult[obj].questionArray) {
            if (this.$route.hash[2]) {
              if (
                this.searchResult[obj].questionArray[i].id ==
                this.$route.hash[1] + this.$route.hash[2]
              ) {
                this.$store.state.question = this.searchResult[
                  obj
                ].questionArray[i];
                this.openModal("faq");
              }
            } else {
              if (
                this.searchResult[obj].questionArray[i].id ==
                this.$route.hash[1]
              ) {
                this.$store.state.question = this.searchResult[
                  obj
                ].questionArray[i];
                this.openModal("faq");
              }
            }
          }
        }
      }, 0);
    }

    this.$store.state.loading = false;
  },
};
</script>

<style>
.faq {
  display: block;
  width: 100%;
  max-width: 768px;
  margin: 15px auto;
  padding: 13px;
  border-radius: 8px;
  box-shadow: 0px 0px 10px rgba(61, 61, 61, 0.2);
  background-color: #fff;
}

.faq .faq-title {
  position: relative;
  margin-bottom: 5px;
  color: #3c3c3c;
  font-size: 15px;
  transition: all 0.2s linear;
  cursor: pointer;
}

.faq .faq-title::after {
  content: "";
  position: absolute;
  top: 50%;
  right: 95%;
  transform: translateY(-50%) rotate(0deg);
  float: left;
  cursor: pointer;

  width: 30px;
  height: 30px;
  background-image: url("../../../public/images/down-circular-button.svg");
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
  transition: all 0.2s linear; /* arrow down icon */
}

.faq.open .faq-title::after {
  transform: translateY(-50%) rotate(-180deg);
}

/* .faq .faq-body::before{
  background-image: url("../../../public/images/question.svg");
  content: "";
 
  top: 50%;
  left: 95%;
  transform: translateY(-50%) rotate(0deg);
  float: right;
  cursor: pointer;

  width: 30px;
  height: 30px;

  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
} */

.faq .faq-body {
  color: #3c3c3c;
  font-size: 14px;
  opacity: 0;
  max-height: 0px;
  overflow-y: hidden;
  transition: all 0.08s linear;
}
.open .faq-body {
  cursor: pointer;  
  color: #551E8C;
  margin-top: 22px;
  opacity: 1;
  max-height: 100000px;
}
.highlight {
  background-color: #55c38c;
  color: #fff;
}

.parantez {
  color: #ccc;
}
</style>
